<template>
  <div>
    <a-spin :spinning="spinning" tip="云码生成中，请稍后...">
      <a-card
        :bordered="false"
        :title="pageStatus==='reprint'?'重新打印云码':'打印云码'"
      >
        <a-button
          slot="extra"
          class="mr-10"
          @click="handleCancel"
        >
          取消
        </a-button>
        <a-button
          slot="extra"
          type="primary"
          :loading="confirmLoading"
          @click="handleConfirm"
        >
          确认打印
        </a-button>
        <div id="oId" style="display: none">
          {{ formData.orderId }}
        </div>
        <!-- 表单 -->
        <a-form-model
          ref="form"
          :model="formData"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item label="类型">
            {{ formData.relation_type | valInDict(dict.relationTypeDict) }}
          </a-form-model-item>
          <a-form-model-item label="页面/商品名称">
            {{ formData.relation_name }}
          </a-form-model-item>
          <!-- 所属品牌 -->
          <a-form-model-item
            label="所属品牌"
            prop="brand"
          >
            <!-- 创建订单才能编辑品牌 -->
            <a-select v-if="!ban" style="width: 300px" placeholder="选择品牌" v-model="formData.brand_id">
              <a-select-option v-for="(item, index) in brand_list" :key="index" :value="item.brand_id">{{ item.brand_name }}</a-select-option>
            </a-select>
            <a-select v-else style="width: 300px" placeholder="选择品牌" v-model="formData.brand_id" disabled>
              <a-select-option v-for="(item, index) in brand_list" :key="index" :value="item.brand_id">{{ item.brand_name }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <!-- 打印数量 -->
          <a-form-model-item
            label="打印数量"
            prop="security_code_count"
            :help="pageStatus==='create'?'确认打印后即扣除云码数量':'已经打印过的云码再次打印不再扣除云码数量'"
          >
            <a-input-number
              v-if="pageStatus==='create'"
              v-model="formData.security_code_count"
              :min="1"
              :precision="0"
            />
            <span v-else>{{ formData.security_code_count }}</span>
          </a-form-model-item>
          <!-- 打印序号 重新打印才显示 -->
          <a-form-model-item
            v-if="pageStatus==='reprint'"
            label="打印序号"
          >
            {{ formData.start_sc_id }} - {{ formData.end_sc_id }}
            <!-- 重新打印才显示 -->
            <a-button
              type="link"
              @click="handleEditIndex"
            >
              修改打印序号
            </a-button>
          </a-form-model-item>
          <!-- 打印模板 -->
          <a-form-model-item
            label="打印模板"
            prop="template_id"
          >
            <a-select
              v-model="formData.template_id"
              allowClear
              placeholder="请选择打印模板"
              style="width: 250px"
            >
              <a-select-option
                v-for="item in templateList"
                :key="item.template_id"
                :value="item.template_id"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <a-button
              type="link"
              @click="handleAddPrintMould"
            >
              新建模板
            </a-button>
            <!-- 效果图 props: mouldData -->
            <print-mould
              v-if="templateDetail"
              :mouldData="templateDetail"
            />
          </a-form-model-item>
          <a-form-model-item
            label="打印方式"
            prop="order_type"
          >
            <a-radio-group v-model="formData.order_type">
              <a-radio
                v-for="item in dict.orderTypeDict"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </a-radio>
            </a-radio-group>
            <div class="tip" v-if="formData.order_type==='PLATFORM'">平台打印最少起订量为2000张，一张为0.05元</div>
          </a-form-model-item>
          <template v-if="formData.order_type==='PLATFORM'">
            <a-form-model-item label="打印订单金额">
              <div style="color:red;font-size:16px">{{ totalPrice ? `￥${totalPrice}` :'抱歉，您要打印的数量计费方案有误，请联系客服处理' }}</div>
            </a-form-model-item>
            <a-form-model-item
              label="收货地址"
              prop="address_id"
            >
              <a-button
                type="primary"
                size="small"
                class="ml-10"
                @click="handleSelectAddress"
              >
                选择地址
              </a-button>
              <div v-if="formData.address_id">
                <div style="border:1px solid #eee; display: inline-block;padding:6px 20px">{{ addressObj.receiver }} &nbsp;&nbsp; {{ addressObj.phone }}<br>{{ addressObj.address }}</div>
              </div>
            </a-form-model-item>
            <a-form-model-item
              label="支付方式"
              prop="pay_type"
            >
              <a-radio-group v-model="formData.pay_type">
                <a-radio
                  v-for="item in dict.payTypeDict"
                  :key="item.id"
                  :value="item.id"
                >
                  <a-icon v-if="item.id === 'WEIXIN'" type="wechat" />
                  <a-icon v-if="item.id === 'ALIPAY'" type="alipay-circle" />
                  {{ item.name }}
                </a-radio>
              </a-radio-group>
            </a-form-model-item>
          </template>
        </a-form-model>
      </a-card>
    </a-spin>
    <!-- 收货地址选择弹框 -->
    <address-list
      ref="addressList"
      v-model="addressObj"
      @input="formData.address_id = addressObj.address_id"
    />
    <!-- 支付面板弹框 -->
    <pay-panel
      ref="payPanel"
      :default-pay-type="formData.pay_type"
      :price="totalPrice"
      order-type="PRINT"
      @close="toOrderDetailPage"
    />
    <!-- 修改打印序号 -->
    <edit-index-modal
      ref="EditIndexModal"
      :start="formData.start_sc_id"
      :end="formData.end_sc_id"
      :range="printIndexRange"
      @ok="editIndexOk"
    />
    <!-- 打印服务 -->
    <print-service
      ref="PrintService"
      :printData="printData"
      @close="toOrderDetailPage"
    />
    <print-service-new
      ref="PrintServiceNew"
      :printData="printData"
    />
  </div>
</template>

<script>
import PrintMould from '@/components/PrintMould'
import PrintService from '@/components/PrintService'
import PayPanel from '@/components/PayPanel'
import AddressList from '@/components/AddressList'
import EditIndexModal from './components/EditIndexModal'
import PrintServiceNew from '@/components/PrintServiceNew'

import {
  getOrderPre,
  getReprintOrderDetail,
  postReprintOrderAdd,
  getTemplateList,
  getTemplateDetail,
  postOrderAdd,
  getOrderPrinterList
} from '@/api/print'
import { getBrandList } from '@/api/brand'

const defaultFormData = {
  relation_type: '',
  relation_id: '',
  relation_name: '',
  security_code_count: 1,
  template_id: undefined,
  order_type: 'LOCAL',
  address_id: '',
  pay_type: 'WEIXIN',
  brand_id: 1
}
export default {
  name: 'PrintCode',
  components: { PrintService, PrintMould, PayPanel, AddressList, EditIndexModal, PrintServiceNew },
  data() {
    return {
      pageStatus: 'create',
      confirmLoading: false,
      spinning: false,
      order_id: '',
      orderId: '',
      brand_list: [],
      ban: false,
      formData: Object.assign({}, defaultFormData),
      // 字典
      dict: {
        relationTypeDict: [],
        orderTypeDict: [],
        payTypeDict: [],
        printPriceDict: []
      },
      rules: {
        security_code_count: [{ required: true, message: '打印数量必填' }],
        template_id: [{ required: true, message: '打印模板必填' }],
        order_type: [{ required: true, message: '打印方式必填' }],
        address_id: [{ required: true, message: '收货地址必填', trigger: 'change' }],
        pay_type: [{ required: true, message: '支付方式必填' }]
      },
      labelCol: { xxl: { span: 2 }, xl: { span: 3 }, lg: { span: 4 }, md: { span: 5 }, sm: { span: 7 }, xs: { span: 8 } },
      wrapperCol: { xxl: { span: 22 }, xl: { span: 21 }, lg: { span: 20 }, md: { span: 19 }, sm: { span: 17 }, xs: { span: 16 } },
      value: 1,
      templateList: [], // 模板列表
      templateDetail: null, // 模板详情
      addressObj: null, // 收货地址
      printIndexRange: [0, 0], // 打印序号数值范围
      printData: {}, // 打印订单的打印云码表
      timer: null
    }
  },
  created() {
    // 订单id
    this.order_id = this.$route.query && this.$route.query.order_id ? this.$route.query.order_id : ''
    if (this.order_id) {
      // 重新打印
      this.pageStatus = 'reprint'
      this.ban = true
      this.getDetail()
    } else {
      // 新建订单
      this.pageStatus = 'create'
      this.formData = Object.assign({}, defaultFormData)
    }
    const relaid = this.formData.relation_id = this.$route.query && this.$route.query.relation_id ? this.$route.query.relation_id : ''
    const type = this.formData.relation_type =
      this.$route.query && this.$route.query.relation_type ? this.$route.query.relation_type : ''
    this.formData.relation_name =
      this.$route.query && this.$route.query.relation_name ? this.$route.query.relation_name : ''
    // 如果参数是数字 或者 参数没有带“，” 则直接赋值
    if (this.$route.query && this.$route.query.brand_id) {
      const br_id = this.$route.query.brand_id
      if (typeof br_id === 'number' || br_id.indexOf(',') === -1) {
        this.formData.brand_id = Number(br_id)
      } else {
        this.formData.brand_id = Number(br_id.substring(0, br_id.indexOf(',')))
      }
    } else {
      this.formData.brand_id = 1
    }
    const is_index = this.$route.query && this.$route.query.is_index ? this.$route.query.is_index : 'NO'
    if (is_index === 'YES') {
      this.ban = true
    }
    this.getPre(relaid, type)
    this.getTemplateList()
  },
  watch: {
    'formData.template_id': {
      handler(val) {
        if (val) {
          this.getTemplateDetail(val)
        } else {
          this.templateDetail = null
        }
      },
      immediate: true
    }
  },
  computed: {
    totalPrice() {
      const count = this.formData.security_code_count
      const priceArr = []
      this.dict.printPriceDict.forEach((item) => {
        if (count >= item.min_number && count <= item.max_number) {
          priceArr.push(item.price)
        }
      })
      if (priceArr.length) {
        const price = Math.min(...priceArr) || 0
        return (price * count).toFixed(2)
      } else {
        return 0
      }
    }
  },
  methods: {
    // 点击 确认 按钮
    handleConfirm() {
      if (this.formData.order_type === 'PLATFORM' && !this.totalPrice) {
        this.$message.error('您的打印数量不在计价规则内，请修改')
        return false
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.pageStatus === 'reprint') {
            // 重新打印
            this.postReprintOrderAdd()
          } else {
            // 正常打印
            this.postAdd()
          }
          window.localStorage.setItem('ORDERTYPE', this.formData.order_type)
        } else {
          this.$message.error('还有字段未填写，请检查！')
          return false
        }
      })
    },
    selectPrinter() {
      // 选择打印机
      this.spinning = true
      getOrderPrinterList({
        orderId: this.orderId
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            // 打开打印面板
            this.printData = data
            this.$refs.PrintServiceNew.showModal()
            this.spinning = false
          } else if (res.code === 10086) {
            this.timer = setTimeout(() => {
              this.toOrderDetailPage()
              this.spinning = false
              this.timer = null
            }, 3000)
          } else {
            this.spinning = false
          }
        })
        .catch((e) => {
          this.$message.error('请求云码列表失败')
        })
    },
    // 点击 取消 按钮
    handleCancel() {
      this.$router.go(-1)
    },
    // 创建打印订单
    postAdd() {
      this.confirmLoading = true
      postOrderAdd(this.formData)
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.order_id = data.order_id
            this.orderId = data.orderId
            this.orderSuccess()
          }
        })
        .catch((e) => {
          this.$message.error('请求创建打印订单失败')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    // 创建重新打印订单
    postReprintOrderAdd() {
      this.confirmLoading = true
      postReprintOrderAdd(Object.assign({}, this.formData, { re_orderId: this.formData.orderId }))
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.order_id = data.order_id
            this.orderId = data.orderId
            document.getElementById('oId').innerText = data.orderId
            this.orderSuccess()
          }
        })
        .catch((e) => {
          this.$message.error('请求创建重新打印订单失败')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    // 订单创建成功
    orderSuccess() {
      if (this.formData.order_type === 'PLATFORM') {
        // 支付
        this.$refs.payPanel.showModal(this.orderId)
      } else {
        // 自打印订单
        // 需要打印的云码列表
        this.selectPrinter(this.orderId)
      }
    },
    // 获取订单要打印的云码列表
    getOrderPrinterList(orderId) {
      this.spinning = true
      getOrderPrinterList({
        orderId: orderId
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            // 打开打印面板
            this.printData = data
            this.$refs.PrintService.showModal()
            this.spinning = false
          } else if (res.code === 10086) {
            // this.$message.warning('抱歉，云码尚未全部生成，请稍后', 3)
            this.timer = setTimeout(() => {
              this.toOrderDetailPage()
              this.spinning = false
              this.timer = null
            }, 3000)
          } else {
            this.spinning = false
          }
        })
        .catch((e) => {
          this.$message.error('请求云码列表失败')
        })
    },
    // 新建模板
    handleAddPrintMould() {
      this.$router.push({ name: 'printMouldAdd' })
    },
    // 选择地址
    handleSelectAddress() {
      this.$refs.addressList.showModal()
    },
    // 修改打印序号
    handleEditIndex() {
      this.$refs.EditIndexModal.showModal()
    },
    // 预加载
    getPre(id, type) {
      var param = ''
      if (type === 'GOODS') {
        // 是商品的话，需要将id上传服务器获取对应的筛选
        param = [1, id]
      }
      getBrandList(param)
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.brand_list = data
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载失败')
        })
      getOrderPre()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.dict.relationTypeDict = data.relationTypeDict
            this.dict.orderTypeDict = data.orderTypeDict
            this.dict.payTypeDict = data.payTypeDict
            this.dict.printPriceDict = data.printPriceDict
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载失败')
        })
    },
    // 查询重新打印订单详情
    getDetail() {
      getReprintOrderDetail({
        order_id: this.order_id
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.formData = Object.assign({}, defaultFormData, data)
            this.printIndexRange = [data.start_sc_id, data.end_sc_id]
          }
        })
        .catch((e) => {
          this.$message.error('请求查询重新打印订单详情失败')
        })
    },
    // 模板列表
    getTemplateList() {
      getTemplateList({
        page: 1,
        size: 10000
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.templateList = data
          }
        })
        .catch((e) => {
          this.$message.error('请求模板列表失败')
        })
    },
    // 模板详情
    getTemplateDetail(template_id) {
      getTemplateDetail({
        template_id: template_id,
        relation_id: this.formData.relation_id,
        relation_type: this.formData.relation_type
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            // 判断是否有小于12px的字体
            var unit = data.unit
            for (var i = 0; i < unit.length; i++) {
              var _i = unit[i]
              if (_i.type === 'TEXT' && _i.font_size < 2.4) {
                data.unit[i].zoom = this.is360(_i.font_size)
              }
            }
            this.templateDetail = data
          }
        })
        .catch((e) => {
          this.$message.error('请求模板详情失败')
        })
    },
    // 跳转到订单详情页
    toOrderDetailPage() {
      // 打印订单关闭则跳转到订单详情页，避免重复提交订单
      this.$router.push({ name: 'orderDetail', query: { id: this.order_id } })
    },
    // 编辑打印序号
    editIndexOk(data) {
      this.formData.start_sc_id = data.start
      this.formData.end_sc_id = data.end
      this.formData.security_code_count = data.end - data.start + 1
    },
    // 兼容360和谷歌字体不能小于12px的问题
    is360(size) {
      var userAgent = navigator.userAgent
      var isChrome = userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1
      // 判断是否是谷歌
      if (isChrome) {
        return size * 5 / 12
      }
      return 1
    }
  }
}
</script>
